module.exports = __webpack_public_path__ + "img/login-laptop-phone.29d0acaf.png";